import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { useLocation } from "wouter";
import FeedbackForm from "@/components/FeedbackForm";
import { useToast } from "@/hooks/use-toast";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export function feedbackSection(path: string): string {
  const section = path.split(/[?#]/, 1)[0].split("/").filter(Boolean)[0];
  // Do not put IDs, invite tokens, or query strings in feedback metadata.
  return section && /^[a-z-]{1,32}$/.test(section) ? section : "home";
}

export default function GlobalFeedback() {
  const [location] = useLocation();
  const [open, setOpen] = useState(false);
  const { toast } = useToast();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex min-h-10 items-center gap-2 rounded-lg bg-primary px-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Send feedback"
          data-testid="global-feedback-trigger"
        >
          <MessageSquare className="h-4 w-4" aria-hidden="true" />
          Feedback
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send feedback</DialogTitle>
          <DialogDescription>
            Ask a question or tell us what to improve. We only send what you enter here.
          </DialogDescription>
        </DialogHeader>
        <FeedbackForm
          screenContext={feedbackSection(location)}
          onSuccess={() => {
            setOpen(false);
            toast({
              title: "Feedback sent",
              description: "Thank you. Your feedback was sent.",
            });
          }}
        />
      </DialogContent>
    </Dialog>
  );
}